import { useState, useEffect, useCallback } from 'react';
import { apiCall } from '../../../_services/apiCall';
import config from "../../../config/config";

/**
 * Loads the two activity logs shown at the bottom of the dashboard:
 * `todaysActivities` (data-owner activity for the current locations/FY) and
 * `usersActivities` (global user activity log).
 *
 * @param {{ locationOptions: object[], financialYearId: number|string }} params
 * @returns {{ usersActivities: object[], todaysActivities: object[] }}
 */
export const useActivityFeeds = ({ locationOptions, financialYearId }) => {
  const [usersActivities, setUsersActivities] = useState([]);
  const [todaysActivities, setTodaysActivities] = useState([]);

  const fetchTodaysActivities = useCallback(async () => {
    const locationIds = locationOptions
      .filter(item => item.value !== undefined)
      .map(item => item.value);

    if (locationIds.length) {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}todaysActivity`,
        {},
        { locationIds, financialYearId },
        "GET"
      );
      if (isSuccess) {
        setTodaysActivities((data?.data).reverse());
      }
    }
  }, [locationOptions, financialYearId]);

  useEffect(() => {
    if (locationOptions.length) {
      fetchTodaysActivities();
    }
  }, [locationOptions, financialYearId, fetchTodaysActivities]);

  const fetchUsersActivities = useCallback(async () => {
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}usersActivity`,
      {},
      {},
      "GET"
    );
    if (isSuccess) {
      setUsersActivities((data?.data));
    }
  }, []);

  useEffect(() => {
    fetchUsersActivities();
  }, [fetchUsersActivities]);

  return { usersActivities, todaysActivities };
};
